import { css } from 'styled-components';
import { CALCULATION_CHECKBOX_CLASS_NAME } from './CalculationCheckbox/CalculationCheckbox';
import { COLORS } from '../../../../styles/style';

const sharedCalculationRowStyles = css`
  .ant-table-wrapper .ant-table.ant-table-middle .ant-table-tbody > tr > td {
    padding: 0;
  }

  .ant-table-cell.final-redistribution-cell {
    position: relative;
    padding: 0;
  }

  .calculationRow {
    &.privateRow {
      background-color: #fffcf6;

      &:hover > td {
        background: #ffefcf !important;
      }
    }

    &.customExport {
      &.done {
        background-color: ${COLORS.CUSTOM_EXPORT_DONE};
      }
      &.warning {
        background-color: ${COLORS.CUSTOM_EXPORT_WARNING};
      }
      &.error {
        background-color: ${COLORS.CUSTOM_EXPORT_FAILED};
      }
    }

    &.productionRow {
      background-color: #fafdfa;

      &:hover > td {
        background: #dff1df !important;
      }
    }

    td.final-redistribution-cell {
      padding: 0;
    }
  }

  .ant-table-middle .ant-table-tbody > tr:not(:first-child) > td {
    padding: 0;
  }
`;

export const calculationsTableStyles = css<{ $hasSelectedCalculation: boolean }>`
  ${sharedCalculationRowStyles}

  .calculationRowIncomplete {
    cursor: not-allowed;
  }

  .calculationRow {
    &.expandedRow {
      background-color: #f9f9f9;

      & > td {
        border-bottom: 0;
      }

      &:hover > td {
        background: #f9f9f9 !important;
      }
    }

    &.selectedRow {
      background: #ffefcf !important;
      opacity: 0.7;

      &:hover {
        opacity: 1;
      }

      &:hover > td {
        background: #ffefcf !important;
      }
    }
  }

  tr.ant-table-expanded-row {
    background-color: #fefefe;
  }

  .${CALCULATION_CHECKBOX_CLASS_NAME} {
    opacity: ${p => (p.$hasSelectedCalculation ? 1 : 0)};
  }

  .ant-table-cell-row-hover {
    .${CALCULATION_CHECKBOX_CLASS_NAME} {
      opacity: 1;
    }
  }
`;

export const calculationActionModalTableStyles = css`
  .ant-table-wrapper {
    max-height: 70vh;
  }

  ${sharedCalculationRowStyles}
`;
